export enum ListSports {
  ALLIANZ_GAME_LOTTERY = 'AGL',
  ANGUILLA_LOTTERY = 'ANG',
  SPORT_CAST = 'CAST',
  COLLEGE_BASKETBALL = 'CBB',
  COLLEGE_FOOTBALL = 'CFB',
  COCKPIT = 'CKPT',
  EUROPEAN_SOCCER = 'ESOC',
  E_SPORTS = 'ESPRT',
  MOBADOO = 'MBDO',
  ML_BASEBALL = 'MLB',
  MATCHUPS = 'MU',
  NBA_BASKETBALL = 'NBA',
  NFL_FOOTBALL = 'NFL',
  NHL_HOCKEY = 'NHL',
  PEGA_MAX = 'PMAX',
  PROPOSITIONS = 'PROP',
  RACING = 'RAC',
  LIVE = 'RBL',
  SOCCER = 'SOC',
  TOURNAMENTS = 'TNT',
  // HORSES = 'H ADJ',
}
